import React from 'react'
import { BackIcon ,BackIconV2} from '../Icons';

const GoBack = ({ handleGoBack, customClass }) => {

    const handleGoBackBound = () => {
        console.log('handleGoBack');

        if (handleGoBack) {
            handleGoBack();
        }
    }

    return (
        <div className={'go-back-content-wrapper'}
            onClick={handleGoBackBound}>
            <BackIconV2 className={`menu-icons ${customClass ? customClass : 'menu-icon'} back-icon`} />
        </div>
    )
}

export default GoBack;